const generatePreview = ({ start, type, laneId, entityType, duration, id, linkedEntityId }) => ({
  actions: [],
  alert: { id: null, level: 'None', badgeText: 'Ok', alerts: Array(0) },
  assignedPlanner: '',
  assignedPlannerName: '',
  badges: [],
  canMove: true,
  constraints: [],
  draftSince: '',
  duration: duration || '04:00:00',
  entityType,
  id: id || '',
  isAssignedPlanner: true,
  isDraft: true,
  laneId,
  line1: '',
  line2: '',
  lock: null,
  lockingErrorType: null,
  lockingErrors: null,
  objectId: linkedEntityId || '',
  operationInfo: null,
  references: [],
  serviceCenterId: '',
  showAs: 'tentative',
  splitJobs: [],
  start,
  subBlocks: [],
  tags: [],
  title: '',
  type,
  uri: '',
  isPreview: true,
});

export default generatePreview;
